<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Map.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4">
        <div class="vx-col w-full">
            <vx-card class="grid-view-item overflow-hidden">
                <div id="container-map" v-if="status_mapa">
                    <l-map :center="center" :zoom="10" ref="mymap" style="height: 100%; overflow: hidden;">
                        <l-control-layers :collapsed="true" :position="layersPosition" :sort-layers="true">
                        </l-control-layers>
                        <l-tile-layer :key="tileProvider.name" :name="tileProvider.name" :url="tileProvider.url" :visible="tileProvider.visible" layer-type="base" v-for="tileProvider in tileProviders">
                        </l-tile-layer>
                        <v-marker-cluster>
                            <l-marker :draggable="item.draggable" :key="item.id" :lat-lng.sync="item.position" :visible="item.visible" v-for="item in markers">
                                <l-icon :icon-anchor="staticAnchor">
                                    <img :src="require(`@/assets/images/markers/${item.status}.svg`)" width="17px;"/>
                                </l-icon>
                                <l-popup>
                                    <div class="popup">

                                      <gridPrincipalItem
                                        img="airflow"
                                        :name="item.alias"
                                        :description="$t('Labels.Alias')"
                                      ></gridPrincipalItem>
                                      <vs-divider/>
                                      <valueItem
                                        :value="parseFloat(item.flow).toFixed(2)"
                                        :description="$t('Labels.Flow')"
                                        img="flow"
                                        unit="ft3/h"
                                      ></valueItem>
                                      <valueItem
                                        :value="parseFloat(item.temperature).toFixed(2)"
                                        :description="$t('Labels.Temperature')"
                                        img="temperature"
                                        unit="°C"
                                      ></valueItem>
                                      <valueItem
                                        :value="parseFloat(item.pressure).toFixed(2)"
                                        :description="$t('Labels.Pressure')"
                                        img="pressure"
                                        unit="Psi"
                                      ></valueItem>
                                      <vs-divider/>
                                      <valueItem
                                        :value="item.updated_at.split(' ')[0]"
                                        :description="item.updated_at.split(' ')[1]"
                                        img="fecha"
                                      ></valueItem>
                                      <alertItem :status="item.status === 1? true: false"></alertItem>

                                    <div class="text-center"><vs-button color="primary"  size="small" @click="deviceInformation(item.id)">Ver Más</vs-button></div>

                                </div>
                                </l-popup>
                            </l-marker>
                        </v-marker-cluster>
                    </l-map>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControlLayers
} from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import alertItem from '@/components/alertItem/alertItem.vue'
import { request } from '@/request.js'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
/* global L:true */

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

export default {
  name: 'mapa',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControlLayers,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    gridPrincipalItem,
    valueItem,
    alertItem
  },
  data () {
    return {
      response: [],
      trayectoria: 0,
      tileProviders,
      layersPosition: 'topright',
      center: [20.662396323989693, -103.37640969334421],
      staticAnchor: [12, 27],
      markers: [],
      status_mapa: false,
      status_heat: false
    }
  },
  methods: {
    async getMapa () {
      this.$vs.loading()
      const params = {
        url: 'modelo/airFlow/map',
        method: 'GET'
      }
      await request(params).then(data => {
        data = data.data.data
        const positions = []
        for (const value of data) {
          positions.push([value.location.split(',')[0], value.location.split(',')[1]])
          this.markers.push({
            position: { lat: value.location.split(',')[0], lng: value.location.split(',')[1] },
            alias: value.alias,
            status: value.status,
            updated_at: value.updated_at,
            id: value.air_flow_id,
            pressure: parseFloat(value.pressure).toFixed(2),
            flow: parseFloat(value.flow).toFixed(2),
            temperature: parseFloat(value.temperature).toFixed(2),
            draggable: false,
            visible: true
          })
        }

        this.status_mapa = true
        this.$vs.loading.close()

        const app = this
        setTimeout(function () {
          const maps = app.$refs.mymap.mapObject
          maps.addControl(new L.Control.Fullscreen())
          maps.fitBounds(positions)
        }, 1000)
      })
    },

    deviceInformation (uuid) {
      window.location.href = `/airflow/detail/${uuid}`
    }

  },
  sockets: {
    airflow (payload) {
      this.markers.forEach(markerToModify => {
        if (markerToModify.id === payload.uuid) {
          markerToModify.pressure = parseFloat(payload.pressure || 0).toFixed(2)
          markerToModify.flow = parseFloat(payload.flow || 0).toFixed(2)
          markerToModify.temperature = parseFloat(payload.temperature || 0).toFixed(2)
          markerToModify.status = payload.status
          markerToModify.updated_at = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getMapa()
  }

}
</script>
